<div class="d-flex align-items-center gap-2">
  @if (primaryCapability(); as primary) {
  <button matButton (click)="trigger(primary.action)">
    <mat-icon>{{ primary.icon }}</mat-icon>
    {{ primary.label }}
  </button>
  } @if (menuCapabilities().length > 0) {
  <button matIconButton [matMenuTriggerFor]="actionsMenu" aria-label="More actions">
    <mat-icon>more_horiz</mat-icon>
  </button>
  <mat-menu #actionsMenu="matMenu">
    @for (cap of menuCapabilities(); track cap.action) {
    <button mat-menu-item (click)="trigger(cap.action)" [class.content-action-bar__debug-item]="cap.debugOnly">
      <mat-icon>{{ cap.icon }}</mat-icon>
      <span>{{ cap.label }}</span>
    </button>
    }
  </mat-menu>
  }
</div>
